/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
// userSaga.js
import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchDepartmentListSuccess, fetchDepartmentListFailure, fetchLocationListSuccess, fetchLocationListFailure, fetchHospitalListSuccess, fetchHospitalListFailure, fetchDepartmentList, fetchPromotionsListSuccess, fetchPromotionsListFailure } from './Actions';
import { REQUEST_DEPARTMENT_LIST, REQUEST_HOSPITAL_LIST, REQUEST_LOCATION_LIST, REQUEST_PROMOTION_LIST } from './Constant';
import axios from 'axios';

function* fetchDepartData(action) {

    try {
        const searchVal = action.searchDept ? action.searchDept : 'a';
        let url = `${process.env.REACT_APP_API_BASE_URL}/specializationlist/${searchVal}`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const specializationsResponse = yield call(axios.get, url,{ headers});
        if (specializationsResponse.status === 200 || specializationsResponse.status === 201) {            
            yield put(fetchDepartmentListSuccess(specializationsResponse.data));
        }
    } catch (error) {
    // throw error;
        yield put(fetchDepartmentListFailure(error));
    }

}

function* fetchLocation(action) {

    try {
        const searchVal = action.searchlocation ? action.searchlocation : 'a';
        let url = `${process.env.REACT_APP_API_BASE_URL}/organisationlocality/${searchVal}`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers});
        if (response.status === 200 || response.status === 201) {            
            yield put(fetchLocationListSuccess(response.data));
        }
    } catch (error) {
    // throw error;
        yield put(fetchLocationListFailure(error));
    }

}

function* fetchHospital(action) {

    try {
        const searchVal = action.searchHospital ? action.searchHospital : 'a';
        let url = `${process.env.REACT_APP_API_BASE_URL}/organisationlist/${searchVal}`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers});
        if (response.status === 200 || response.status === 201) {            
            yield put(fetchHospitalListSuccess(response.data));
        }
    } catch (error) {
    // throw error;
        yield put(fetchHospitalListFailure(error));
    }

}

function* fetchPromotionData() {

    try {
        let url = `${process.env.REACT_APP_API_BASE_URL}/socialmediapromotions?isDisabled=false&organisationsId=140`;

        const headers = {
            'Api-Header-Security': process.env.REACT_APP_API_HEADER_SECURITY,
            'x-api-version': process.env.REACT_APP_X_API_VERSION,
        };
        const response = yield call(axios.get, url,{ headers});
        if (response.status === 200 || response.status === 201) {            
            yield put(fetchPromotionsListSuccess(response.data));
        }
    } catch (error) {
    // throw error;
        yield put(fetchPromotionsListFailure(error));
    }

}

// Watcher Saga
export function* watchFetchHome() {
    yield takeEvery(REQUEST_DEPARTMENT_LIST, fetchDepartData);
    yield takeEvery(REQUEST_LOCATION_LIST, fetchLocation);
    yield takeEvery(REQUEST_HOSPITAL_LIST, fetchHospital);
    yield takeEvery(REQUEST_PROMOTION_LIST, fetchPromotionData);



}
